module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0052.jpg?v=12c12afb";